function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.625 6.22a1 1 0 10-1.25 1.56l4 3a1 1 0 001.25 0l4-3a1 1 0 10-1.25-1.56L8 8.72l-3.375-2.5z",
  fill: "#243143"
});

function SvgChevronDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNjI0NzMgNi4yMTkxN0M0LjE5MzQ3IDUuODc0MTYgMy41NjQxOCA1Ljk0NDA4IDMuMjE5MTcgNi4zNzUzNEMyLjg3NDE2IDYuODA2NiAyLjk0NDA4IDcuNDM1OSAzLjM3NTM0IDcuNzgwOTFMNy4zNzUzNCAxMC43ODA5QzcuNzQwNTYgMTEuMDczMSA4LjI1OTUxIDExLjA3MzEgOC42MjQ3MyAxMC43ODA5TDEyLjYyNDcgNy43ODA5MUMxMy4wNTYgNy40MzU5IDEzLjEyNTkgNi44MDY2IDEyLjc4MDkgNi4zNzUzNEMxMi40MzU5IDUuOTQ0MDggMTEuODA2NiA1Ljg3NDE2IDExLjM3NTMgNi4yMTkxN0w4LjAwMDA0IDguNzE5NDFMNC42MjQ3MyA2LjIxOTE3WiIgZmlsbD0iIzI0MzE0MyIvPgo8L3N2Zz4K";
export { SvgChevronDown16 as ReactComponent };